import { useEffect, useState } from "react";
import { collection, query, where, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function MyPredictions() {
  const { currentUser } = useAuth();
  const [predictions, setPredictions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPoints, setTotalPoints] = useState(0);

  useEffect(() => {
    async function fetchPredictions() {
      const predsSnap = await getDocs(
        query(collection(db, "predictions"), where("userId", "==", currentUser.uid))
      );
      const preds = await Promise.all(
        predsSnap.docs.map(async (d) => {
          const pred = { id: d.id, ...d.data() };
          const matchSnap = await getDoc(doc(db, "matches", pred.matchId));
          pred.match = matchSnap.exists() ? matchSnap.data() : null;
          return pred;
        })
      );
      setTotalPoints(preds.reduce((sum, p) => sum + (p.pointsEarned || 0), 0));
      setPredictions(preds);
      setLoading(false);
    }
    fetchPredictions();
  }, [currentUser]);

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#F0F1EC" }}>
      <Navbar />
      <div className="max-w-4xl mx-auto px-6 py-10">
        <div className="flex justify-between items-end mb-10 fade-up">
          <div>
            <p className="font-condensed text-gray-500 tracking-widest uppercase text-sm mb-2">Your Record</p>
            <h2 className="font-display text-7xl tracking-wider" style={{ color: "#0A0B0F" }}>MY PICKS</h2>
          </div>
          <div className="text-right">
            <div className="font-display text-6xl" style={{ color: "#0A0B0F" }}>
              <span className="px-3 py-1 rounded-lg" style={{ backgroundColor: "#C8FF00" }}>{totalPoints}</span>
            </div>
            <div className="font-condensed text-gray-400 tracking-widest uppercase text-sm mt-1">Total Points</div>
          </div>
        </div>

        {loading ? (
          <p className="font-condensed text-gray-400 text-xl">Loading...</p>
        ) : predictions.length === 0 ? (
          <div className="card p-12 text-center">
            <p className="font-condensed text-gray-400 text-xl mb-6">No predictions yet</p>
            <Link to="/events" className="btn-lime px-8 py-3 rounded-xl inline-block">BROWSE FIXTURES</Link>
          </div>
        ) : (
          <div className="space-y-4 fade-up fade-up-delay-1">
            {predictions.map((pred) => {
              const isCompleted = pred.match?.status === "completed";
              const pts = pred.pointsEarned || 0;
              return (
                <div key={pred.id} className="card p-6"
                  style={isCompleted && pts > 0 ? { borderLeft: "4px solid #C8FF00" } : {}}>
                  <div className="flex items-center justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2">
                        <span className="font-condensed text-gray-400 tracking-widest text-xs uppercase">
                          {pred.match?.date}
                        </span>
                        <span className="font-condensed text-xs tracking-wider px-2 py-0.5 rounded-full"
                          style={isCompleted
                            ? { backgroundColor: "#F0F0F0", color: "#999" }
                            : { backgroundColor: "#EDFFD0", color: "#3A6600" }}>
                          {isCompleted ? "FINAL" : "UPCOMING"}
                        </span>
                      </div>
                      <div className="font-display text-2xl tracking-wider mb-1" style={{ color: "#0A0B0F" }}>
                        {pred.match?.homeTeam} <span className="text-gray-300">VS</span> {pred.match?.awayTeam}
                      </div>
                      <div className="font-condensed text-gray-400 tracking-wide text-sm">
                        Predicted: {pred.winner} · {pred.homeScore}–{pred.awayScore}
                        {pred.goalscorer && ` · ${pred.goalscorer} first`}
                      </div>
                      {isCompleted && (
                        <div className="font-condensed text-gray-300 text-sm mt-1">
                          Result: {pred.match?.result}
                          {pred.match?.firstGoalScorer && ` · First: ${pred.match.firstGoalScorer}`}
                        </div>
                      )}
                    </div>
                    <div className="flex items-center gap-4 ml-6">
                      <div className="text-right">
                        <div className="font-display text-4xl"
                          style={{ color: pts > 0 ? "#3A6600" : "#CCC" }}>
                          {isCompleted ? (pts > 0 ? `+${pts}` : "0") : "—"}
                        </div>
                        <div className="font-condensed text-gray-400 text-xs uppercase tracking-wider">pts</div>
                      </div>
                      {!isCompleted && (
                        <Link
                          to={`/predict/${pred.matchId}`}
                          className="font-condensed tracking-wide text-sm px-4 py-2 rounded-lg transition"
                          style={{ border: "1px solid #E0E2DB", color: "#666" }}
                        >
                          EDIT
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}